import { z } from 'zod/v4';

export const LinkDTO = z.object({
  id: z.uuid(),
  name: z.string(),
  label: z.string(),
});
export type Link = z.infer<typeof LinkDTO>;